import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Avatar from '../../assets/images/avatar.png';
import classNames from 'classnames';
export const ProfileImage = ({ size = 'default', edit, role, src = Avatar, className }) => {
    const imgClassName = classNames('rounded-full object-cover', {
        'w-5 h-5': size === 'sm',
        'w-12 h-12': size === 'lg',
        'w-16 h-16': size === 'xl',
        'w-20 h-20': size === '2xl',
        'w-32 h-32': size === '3xl',
        'w-9 h-9': size === 'default'
    });
    const wrapperClassName = classNames('relative flex-none', className);
    const spanClassName = classNames('absolute text-white text-3xs rounded-full px-[2.5px] pt-[1px] pb-[2px] bottom-1 right-0 font-bold', {
        'bg-secondary': role === 'MD' || role === 'PH',
        'bg-primary': role === 'NP',
        'bg-violet': role === 'MA',
        'bg-red': role === 'CS',
        'bg-orange': role === 'AD',
        '-right-[3px] -bottom-px': size === 'sm'
    });
    const handleError = (e) => {
        e.target.onerror = null;
        e.target.src = Avatar;
    };
    return (_jsxs("div", { className: wrapperClassName, children: [_jsx("img", { alt: "profile image", className: imgClassName, "data-testid": "profile_image", src: src || Avatar, onError: handleError }), role && !edit && _jsx("span", { className: spanClassName, children: role }), edit && size === 'lg' && (_jsx("span", { className: "absolute bottom-0.5 text-white left-3.5 text-xs font-normal", children: "Edit" }))] }));
};
